import { generateID } from '@domain-group/javascript-utils'

export type ImageDownloadPresetModel = {
  height: number,
  key: string,
  title: '',
  width: number,
}

const state = {
  height: '',
  key: generateID(),
  title: '',
  width: '',
}

export const requiredFields = [
  { key: 'height' },
  { key: 'key' },
  { key: 'title' },
  { key: 'width' },
]

export default state
